/**
 * Veroni "You may also like" — fix #7.
 *
 * Horizon's <product-recommendations> element renders 4 skeleton ghost
 * boxes server-side (before hydration) and self-hides only when the
 * hydrated fetch returns exactly zero products
 * (`product-recommendations:has([data-has-recommendations='false'])` in
 * base.css). With a small catalog (this store currently has ~1-2 other
 * active products), that left 1-2 lonely real cards behind a section
 * that had just flashed 4 empty ones, or a single-card section that reads
 * as broken rather than intentional.
 *
 * assets/veroni-theme.css already hides the skeleton boxes outright (no
 * ghost-card flash at all). This script covers the other half: once the
 * Section Rendering API hydration lands (morphSection swaps the element's
 * DOM), count the real `.resource-list__item` cards and hide the whole
 * <product-recommendations> element when there are fewer than 2 — "render
 * nothing rather than empty/lonely boxes", per spec. Zero products is
 * already handled by Horizon's own CSS rule; this only adds the
 * fewer-than-2 case on top, and doesn't touch cart/variant/recommendation
 * fetch logic at all (pure display toggle after the fact).
 */
(function () {
  var MIN_RECOMMENDATIONS = 2;

  // The cards are rendered for the product's first stone in yellow gold (the
  // section fetch carries no variant). Pin each to the stone and gold selected on
  // the product page by pressing its own dots (assets/veroni-catalog.js), so the
  // photo and link match what the shopper is looking at (owner 2026-10-20).
  var GOLD_VALUE = /^(yellow|white|rose) gold$/i;

  function pdpSelection() {
    var picker = document.querySelector('variant-picker[data-template-product-match="true"]');
    if (!picker) return null;
    var selection = { stone: '', gold: '' };
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
      var gold = (input.value || '').match(GOLD_VALUE);
      if (gold) selection.gold = gold[1].toLowerCase();
      else if (!selection.stone) selection.stone = input.value;
    });
    return selection.stone || selection.gold ? selection : null;
  }

  function pinCards(el) {
    var selection = pdpSelection();
    if (!selection) return;
    var key = selection.stone + '|' + selection.gold;
    el.querySelectorAll('[data-veroni-card]').forEach(function (card) {
      if (card.dataset.veroniRecPin === key) return;
      card.dataset.veroniRecPin = key;
      if (selection.stone) {
        var stone = selection.stone.toLowerCase();
        var gem = Array.prototype.filter.call(card.querySelectorAll('[data-veroni-gem]'), function (button) {
          return (button.getAttribute('title') || '').toLowerCase() === stone;
        })[0];
        if (gem) gem.click();
      }
      if (selection.gold) {
        var metal = card.querySelector('[data-veroni-metal="' + selection.gold + '"]');
        if (metal) metal.click();
      }
    });
  }

  function evaluate(el) {
    pinCards(el);
    var count = el.querySelectorAll('.resource-list__item').length;
    if (el.dataset.recommendationsPerformed === 'true' && count < MIN_RECOMMENDATIONS) {
      el.setAttribute('data-veroni-hide', '');
    } else if (count >= MIN_RECOMMENDATIONS) {
      el.removeAttribute('data-veroni-hide');
    }
  }

  function watch(el) {
    if (el.veroniRecommendationsWatched) return;
    el.veroniRecommendationsWatched = true;

    evaluate(el);

    var observer = new MutationObserver(function () {
      evaluate(el);
    });
    observer.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-recommendations-performed'] });
  }

  function init() {
    document.querySelectorAll('product-recommendations').forEach(watch);
  }

  document.addEventListener('change', function (event) {
    var picker = event.target && event.target.closest && event.target.closest('variant-picker[data-template-product-match="true"]');
    if (!picker) return;
    window.setTimeout(function () {
      document.querySelectorAll('product-recommendations').forEach(pinCards);
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Recommendations sections can also be injected later (quick-add modal,
  // section re-render) — watch for new instances the same way the gallery
  // script does.
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('product-recommendations')) {
            watch(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('product-recommendations').forEach(watch);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
